import { memo } from 'react'

import { areEqual } from 'react-window'

import { Box, Td, Tr } from '@chakra-ui/react'

import { RulesType } from '../utils/utils'

interface RenderRowIProps {
  data: {
    handleToggleSwitch: (rule: RulesType) => void
    handleOnRemove: (rule: RulesType) => void
    onRowClick: (id: string, isV2: boolean, event: React.MouseEvent) => void
    prepareRow: any
    selectedId: string
    items: {
      getRowProps: any
      cells: any
      original: {
        id: string
        isV2: boolean
        ruleName: string
        lastMatched: string
        createdAt: string
        active: RulesType
      }
    }[]
  }
  index: number
  style: any
}

export const TableRow = memo<RenderRowIProps>(
  ({ data, index, style }: RenderRowIProps) => {
    const {
      items,
      prepareRow,
      handleToggleSwitch,
      handleOnRemove,
      onRowClick,
    } = data
    const row = items[index]
    prepareRow(row)

    return (
      <Tr
        {...row.getRowProps({
          style,
        })}
        _hover={{
          bgColor: 'gray.100',
        }}
        bgColor='#fff'
        cursor='pointer'
        h='40px'
        key={index}
        onAuxClick={(event: React.MouseEvent) => {
          // Middle-click only; browsers also fire auxclick for the right button.
          if (event.button === 1) {
            onRowClick(row.original.id, row.original.isV2, event)
          }
        }}
        onClick={(event: React.MouseEvent) =>
          onRowClick(row.original.id, row.original.isV2, event)
        }
        transition='ease-in-out'
        transitionDuration='300ms'
        transitionProperty='all'
      >
        {row.cells.map((cell, i) => (
          <Td
            {...cell.getCellProps()}
            alignItems='center'
            borderColor='#D5DCE4'
            color='#2D2E41'
            flexDirection='row'
            fontSize='14px'
            fontWeight='medium'
            isNumeric={cell.column.isNumeric}
            key={`${row.original.ruleName}-row${i}`}
            letterSpacing='-0.53px'
            pos='relative'
            px='4'
            py='0'
          >
            <Box pos='relative' top='50%' transform='translateY(-50%)'>
              {cell.render('Cell', {
                onChange: handleToggleSwitch,
                onRemove: handleOnRemove,
              })}
            </Box>
          </Td>
        ))}
      </Tr>
    )
  },
  areEqual
)
